//#region src/utils/array-values-or-undefined.ts
function arrayValuesOrUndefined(arr) {
	if (Array.isArray(arr) && arr.length) return arr;
}
//#endregion
export { arrayValuesOrUndefined };

//# sourceMappingURL=array-values-or-undefined.js.map